import { Injectable } from '@angular/core';
import { Language } from '@app/models/language';
import {
  FetchLanguages,
  FetchLanguagesFail,
  FetchLanguagesSuccess,
  LanguagesActionTypes
} from '@app/pcs/actions/language';
import { LanguageDataService } from '@app/pcs/services/language-data.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, exhaustMap, switchMap } from 'rxjs/operators';

@Injectable()
export class LanguageEffects {

  fetchLanguages$ = createEffect(() => this.actions$.pipe(
    ofType<FetchLanguages>(LanguagesActionTypes.FetchLanguages),
    exhaustMap(() =>
      this.languageDataService.getLanguages().pipe(
        switchMap((language: Language[]) => of(new FetchLanguagesSuccess(language))),
        catchError(error => of(new FetchLanguagesFail(error)))
      )
    )
  ));

  constructor(
    private actions$: Actions,
    private store: Store<any>,
    private languageDataService: LanguageDataService
  ) {
  }
}
